export const LOAD_TRANSACTION_CATEGORY_SPEND = 'LOAD_TRANSACTION_CATEGORY_SPEND'
export const RECEIVE_TRANSACTION_CATEGORY_SPEND = 'RECEIVE_TRANSACTION_CATEGORY_SPEND'
